import React from "react";
import useDumbPageTitle from "hooks/useDumbPageTitle";
import { useTrackPageView } from "hooks/useTrackPageView";
import ProgressIndicator from "components/ProgressIndicator";
import { ChartList } from "components/DataExplorationV2/ChartList";
import { useGetAlertChartFromParam } from "hooks/data-exploration-v2/useGetAlertChartFromParam";

/** The title of the page */
const PAGE_TITLE = "Data Exploration";

export const DataExplorationPageV2 = (): JSX.Element => {
  useDumbPageTitle(PAGE_TITLE);
  useTrackPageView(PAGE_TITLE);
  const { loading, alertChart } = useGetAlertChartFromParam();

  if (loading) {
    return <ProgressIndicator loading={loading} />;
  } else {
    return <ChartList initialChart={alertChart} />;
  }
};
